import {
  DsButton,
  DsCard,
  DsDialog,
  DsExplorerLink,
  DsTag,
} from '@tokenyico/design-system/dist/reactJS';
import { formActions } from 'app/state/actions';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'redux-zero/react';
import { DFNSService } from 'services';

const Integrated = ({ unverifiedWallet, onVerified, setError, selectedToken }) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const network = selectedToken.blockchainNetwork;

  const ref = useRef();
  useEffect(() => {
    ref.current.open();
  }, []);

  const register = async () => {
    setIsSubmitting(true);
    try {
      await DFNSService.register({ walletAddress: unverifiedWallet.walletAddress });
      onVerified();
    } catch (e) {
      if (e instanceof DOMException && e.name === 'NotAllowedError') {
        // catch user dismissed and timeout errors
        setError(t('verifyWallet.integrated.NotAllowedError'));
      } else {
        setError(e);
      }
    }
  };

  return (
    <DsDialog id="unverifiedWallet" isModal isDismissible={false} ref={ref}>
      <h1>{t('verifyWallet.integrated.title')}</h1>
      <p className="_text-reg">{t('verifyWallet.integrated.text')}</p>
      <DsTag
        version="info"
        size="sm"
        icon="info"
        iconSize="1rem"
        isSquare
        label={t('verifyWallet.integrated.info')}
        className="_my-3"
      />
      <DsCard shadowDistance="0" padding="3">
        <div>
          <p className="_fontw-500">{t('verifyWallet.integrated.yourWalletAddress')}</p>
          <DsExplorerLink
            isCopyable
            type="wallet"
            address={unverifiedWallet.walletAddress}
            network={network}
          />
        </div>
      </DsCard>
      <DsButton
        isFullWidth
        isReverse
        label={t('verifyWallet.integrated.claimWallet')}
        icon="open-to-right"
        version="info"
        onClick={register}
        isSubmitting={isSubmitting}
        className="_mtop-3"
      />
    </DsDialog>
  );
};

export default connect((state) => state.holder, formActions)(Integrated);
